/**
 * Settings module translations - Modals section
 */

const modals = {
  addKsefTokenTitle: "Add KSeF token",
  manageKsefTokenTitle: "Manage KSeF token",
  ksefReplaceWarning: "Previous token will be replaced",
  ksefTokenRequired: "KSeF token is required",
  removeKsefTokenConfirm: "Remove the stored KSeF token? You can add a new one later.",
  deleteKsefTokenTitle: "Delete KSeF token",
  deleteKsefTokenDescription:
    "Are you sure you want to remove the stored KSeF token? You can add a new one later.",
  deleteBankTitle: "Delete bank?",
  deleteBankDescription: "Are you sure you want to delete the bank \"{{bankName}}\"?",
  editProduct: "Edit product",
  addProduct: "Add product",
  deleteProductTitle: "Delete product",
  deleteProductDescription: "Are you sure you want to delete \"{{productName}}\"?",
  errorAddingProduct: "Error adding product",
  errorUpdatingProduct: "Error updating product",
  errorDeletingProduct: "Error deleting product",
};

export default modals;
